module.exports = __webpack_public_path__ + "static/media/zxs_glxt.a6d49244.png";